export default __webpack_public_path__ + "static/media/icon_romanFeet_left.debe4e37.png";